import { UrlHelper } from "./url.helper";

const DEFAULT_MAX_URL_LENGTH = 2000;

interface SplitUrlOptions {
  paramKey?: string;
  maxUrlLength?: number;
  separator?: string;
}

export const splitUrlByQueryParam = (
  fullUrl: string,
  options: SplitUrlOptions = {}
): string[] => {
  const {
    paramKey,
    maxUrlLength = DEFAULT_MAX_URL_LENGTH,
    separator = ",",
  } = options;

  if (fullUrl.length <= maxUrlLength) {
    return [fullUrl];
  }

  const [baseUrl, queryString = ""] = fullUrl.split("?");
  const parsedQuery = UrlHelper.parse(queryString);

  let keyToSplit = paramKey;

  // Auto-detect long key if not provided
  if (!keyToSplit) {
    keyToSplit = Object.entries(parsedQuery).reduce((longest, [key, value]) => {
      const length = decodeURIComponent(String(value)).length;
      return length > (parsedQuery[longest]?.length || 0) ? key : longest;
    }, Object.keys(parsedQuery)[0]);
  }

  const rawValue = parsedQuery[keyToSplit];
  if (!rawValue || typeof rawValue !== "string") {
    return [fullUrl];
  }

  const items = decodeURIComponent(rawValue).split(separator);
  const { [keyToSplit]: _, ...baseQueryWithoutSplitParam } = parsedQuery;

  const resultUrls: string[] = [];
  let chunk: string[] = [];

  for (const item of items) {
    const nextChunk = [...chunk, item];
    const url = UrlHelper.parametrize(baseUrl, {
      ...baseQueryWithoutSplitParam,
      [keyToSplit]: nextChunk.join(separator),
    });

    if (url.length > maxUrlLength && chunk.length > 0) {
      resultUrls.push(
        UrlHelper.parametrize(baseUrl, {
          ...baseQueryWithoutSplitParam,
          [keyToSplit]: chunk.join(separator),
        })
      );
      chunk = [item]; // start new
    } else {
      chunk = nextChunk;
    }
  }

  if (chunk.length) {
    resultUrls.push(
      UrlHelper.parametrize(baseUrl, {
        ...baseQueryWithoutSplitParam,
        [keyToSplit]: chunk.join(separator),
      })
    );
  }

  return resultUrls;
};
